import React from 'react';
import { Link } from 'react-router-dom';
import './card-style.css';





function PremiumEventCard(props) {
    let { id, category, count, grade, time, totalquestions, premiumlevel } = props.eventcategory;

    const noofquestions = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100];
    const [noofquestion, set_noofquestion] = React.useState();
    function setQuestionNo(questionnumber) {
        //event_copy.totalquestions = questionnumber

        // event_copy.start_limit = 9
        // event_copy.end_limit = 12

        // event_copy.start_limit = 0;
        // event_copy.end_limit = questionnumber - 1;
        // event_copy.randomize = random;
    }

    return (
        <div className="card text-center shadow">

            <div className="overflow">
                {<Link to={{ pathname: "/" + props.target, state: { category: category, grade: grade, premiumlevel: premiumlevel, time: time, totalquestions: totalquestions, sendEmail: false } }}>
                    {
                        <img src={props.imgsrc} alt='QuizWizard' className='card-img-top' width="200" height="250" />
                    }

                </Link>}
                <div className="card-body text-dark">
                    <h4 className="card-text">{category}</h4>
                    <h4 className="card-text">{count} Event</h4>
                    {/* <span className="custom-dropdown">
                        <select
                            name="noofquestion"
                            value={noofquestion}
                            placeholder="No of Questions"
                            onChange={e => setQuestionNo(e.target.value)}
                            required>
                            <option key="">No of Questions</option>
                            {noofquestions.filter(ques => ques <= totalquestions).map(filteredques => (
                                // {noofquestions.map(questionno => (
                                <option key={filteredques}>{filteredques}</option>
                            ))}

                        </select>
                    </span> */}
                </div>
            </div>
        </div>

    );
}






export default PremiumEventCard;
